import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ReportsService} from './services';
import {CreateTradesTableConfigPipe, GetKeysPipe} from './pipes';
import {ReportingModuleConfig, IReportingModuleConfig} from './common';
import {ReportingTableComponent, TradesReportComponent} from './components';

@NgModule({
    declarations: [
        ReportingTableComponent,
        TradesReportComponent,
        GetKeysPipe,
        CreateTradesTableConfigPipe,
    ],
    imports: [CommonModule],
    exports: [TradesReportComponent]
})
export class ReportingModule {
    static forRoot(moduleConfig: IReportingModuleConfig): ModuleWithProviders<ReportingModule> {
        return {
            ngModule: ReportingModule,
            providers: [
                {provide: ReportingModuleConfig, useValue: moduleConfig},
                ReportsService
            ]
        };
    }
}
